'use strict';

var $ = require('jquery');
// require('tablesaw/dist/tablesaw.jquery.js')(window, $);
require('tablesaw');
var Debouncer = require('../lib/Debouncer.js');

var defaultMode = 'stack';
var wrapperStyleClass = 'table-wrapper';

function init() {
	var $tables = $('main table');
	if ($tables.length < 1) {
		return;
	}

	var $win = $(window);

	$tables.each(function (i) {
		var $this = $(this);
		if ($this.find('thead th').length == 0) {
			// Tablesaw will not support this table so wrap with a div we can provide a srollbar on
			$this.wrap('<div class="' + wrapperStyleClass + '" />');
		} else {
			// Setup tablesaw
			$this.find('td[colspan], th[colspan]').attr('colspan', '');

			if ($this.attr('data-tablesaw-mode') === undefined) {
				$this.attr('data-tablesaw-mode', defaultMode);
			}
			$this.attr('data-tablesaw-minimap', '');
			$this.tablesaw()
				.data('tablesaw')
				.refresh();
		}
	});

	function toggleTableClassIfOverflow() {
		$tables.each(function (i) {
			var $this = $(this);
			var overflowedAt = $this.data('overflowedAt');

			if (overflowedAt !== undefined) {
				// Has overflowed
				if (overflowedAt < $win.width()) {
					// Window grew larger than what triggered overflowing table.
					$this.removeData('overflowedAt');
					$this.removeClass('table--tooWide');
				}
			} else {
				// Has not yet overflowed so check if it is now

				var $parent = $this.parent();
				var parentRight = $parent.offset().left + $parent.outerWidth();
				var thisRight = $this.offset().left + $this.outerWidth();

				// Test if right side of table beyond right side of main
				if (thisRight > parentRight) {
					// Table too wide. Store width it was at so we don't remove class until greater then
					$this.data('overflowedAt', $win.width());
					$this.addClass('table--tooWide');
				}
			}
		});
	}

	toggleTableClassIfOverflow();

	var scrollDebouncer = new Debouncer(toggleTableClassIfOverflow);
	$(window).on('resize.tablesaw', scrollDebouncer.run);
}

module.exports = {
	init: init
};
